var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('content-unit-box',{staticClass:"color-content-unit-box",style:(_vm.setStyle()),on:{"click":_vm.clickEvent}},[_c('div',{staticClass:"color-content-unit-box__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }